// extracted by mini-css-extract-plugin
export default {"text":"Body_text__t4vDd"};